import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcec6c50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout layout--left-right" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "scores user-input" }
const _hoisted_4 = { class: "scores previous-input print--hide" }

import { onMounted, ref, useSlots } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'left-right-layout',
  setup(__props) {

  const syncedSlotNames = ref<Array<string>>([]);

  onMounted(() => {
    syncedSlotNames.value = [];
    const slots = useSlots();
    for (const key of Object.keys(slots)) {
      if (key.indexOf("synced-input-") === 0) syncedSlotNames.value.push(key);
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "label")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "user-input")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "previous-input")
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(syncedSlotNames.value, (syncedSlot, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "scores synced-input print--hide"
          }, [
            _renderSlot(_ctx.$slots, syncedSlot)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "keywords")
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "more-button")
    ])
  ]))
}
}

})